/**
 * Index gate — mock auth until Cognito (Fase 5).
 */

import { isAuthenticated, resolveAppPath } from "/assets/js/auth.js";
import { CONFIG } from "/assets/js/config.js";
import { resolveSessionLanding } from "/assets/js/permission_control/session-landing.js";
import { registerHearPwa } from "/assets/js/pwa/pwa-register.js";

function checkAuth() {
  if (isAuthenticated()) {
    window.location.href = resolveAppPath(resolveSessionLanding());
    return;
  }
  window.location.href = resolveAppPath(CONFIG.LOGIN_PATH);
}

void registerHearPwa();
checkAuth();
